import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import React from 'react';
import Transform from '@/components/Transform';
import { publicPath } from '@/utils';
import styles from './index.module.scss';

const CommonCases = ({
  data
}) => /*#__PURE__*/React.createElement(Transform, null, data.map((item, i0) => /*#__PURE__*/React.createElement("div", {
  key: i0
}, /*#__PURE__*/React.createElement("div", {
  className: styles.card_img
}, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
  src: publicPath(item.img)
}))), /*#__PURE__*/React.createElement("div", {
  className: styles.card_cont
}, /*#__PURE__*/React.createElement("h3", null, item === null || item === void 0 ? void 0 : item.title), item.content.map((cont, i1) => /*#__PURE__*/React.createElement("p", {
  key: i1
}, cont)), /*#__PURE__*/React.createElement("ul", null, item.tips.map((tip, i2) => {
  return /*#__PURE__*/React.createElement("li", {
    key: i2
  }, /*#__PURE__*/React.createElement("p", null, tip === null || tip === void 0 ? void 0 : tip.title), /*#__PURE__*/React.createElement("p", null, tip === null || tip === void 0 ? void 0 : tip.desc));
})), (item === null || item === void 0 ? void 0 : item.source) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Divider, null), /*#__PURE__*/React.createElement("span", {
  className: styles.footnote
}, item.source))))));

export default CommonCases;